import { Container } from 'pixi.js';
import type { Signal } from 'typed-signals';
import { RaceEventJoinLayout } from '../../../../layouts/raceEvent/RaceEventJoinLayout';
import { playLayoutAnimation } from '../../../libs/layouts/layoutAnimations/playLayoutAnimation';

export class RaceEventPopupJoinView extends Container {
  private readonly layout = new RaceEventJoinLayout();

  constructor(onJoinedClicked: Signal<() => void>) {
    super();

    const {
      layout,
      layout: { carLayout },
    } = this;

    void playLayoutAnimation(layout, 'Smoke_Animation', false);
    void playLayoutAnimation(layout, 'Trophy_Idle', true);
    void playLayoutAnimation(layout, 'Button_Idle', true);
    void playLayoutAnimation(carLayout, 'Tires_Idle', true);
    void playLayoutAnimation(carLayout, 'Car_Idle', true);
    void playLayoutAnimation(carLayout, 'Car_Idle_2', true);

    layout.root.props({
      parent: this,
    });
    layout.joinButton.root.on('pointerdown', () => {
      onJoinedClicked.emit();
    });
  }
}
